import { defineComponent, computed } from 'vue';
import __vue_component__$1 from '../../buttons/ClickableRouterLink.vue.js';
import { CardStyle } from './model.js';
import __vue_component__ from '../../ui/Loading/Loading.vue.js';

var script = defineComponent({
    name: 'BasicCard',
    components: {
        Loading: __vue_component__,
    },
    props: {
        alignLeft: Boolean,
        boxShadow: Boolean,
        cardStyle: {
            type: String,
            default: 'info',
        },
        clickable: Boolean,
        clickableNoStyle: Boolean,
        displayFlag: Boolean,
        flagPosition: {
            type: String,
            default: 'left',
        },
        flagColor: {
            type: String,
            default: 'green',
        },
        isLoading: Boolean,
        newPadding: Boolean,
        noPadding: Boolean,
        selected: Boolean,
        to: {
            type: [String, Object],
            default: null,
        },
    },
    setup(props, { emit }) {
        const componentIs = computed(() => props.to ? __vue_component__$1 : 'div');
        const classNames = computed(() => {
            const names = [];
            if ((props.clickable || props.to) && !props.clickableNoStyle) {
                names.push('BasicCard--clickable', 'BasicCard--cursor-pointer');
            }
            if (props.alignLeft)
                names.push('BasicCard--align-left');
            if (props.clickableNoStyle)
                names.push('BasicCard--cursor-pointer');
            if (props.isLoading)
                names.push('BasicCard--loading');
            if (props.boxShadow)
                names.push('BasicCard--box-shadow');
            if (props.noPadding)
                names.push('BasicCard--no-padding');
            if (props.newPadding)
                names.push('BasicCard--new-padding');
            if (props.selected)
                names.push('BasicCard--selected');
            switch (props.cardStyle) {
                case CardStyle.INFO:
                    names.push('BasicCard--info');
                    break;
                case CardStyle.FROSTED:
                    names.push('BasicCard--frosted');
                    break;
                case CardStyle.DANGER:
                    names.push('BasicCard--danger');
                    break;
                case CardStyle.PRIMARY:
                    names.push('BasicCard--primary');
                    break;
                case CardStyle.WHITE:
                    names.push('BasicCard--white');
                    break;
                case CardStyle.WHITE_WITH_BORDER:
                    names.push('BasicCard--white-with-border');
                    break;
                case CardStyle.WHITE_WITH_BORDER_DANGER:
                    names.push('BasicCard--white-with-border-danger');
                    break;
                case CardStyle.WHITE_WITH_BORDER_WARNING:
                    names.push('BasicCard--white-with-border-warning');
                    break;
                case CardStyle.GREY:
                    names.push('BasicCard--grey');
                    break;
                case CardStyle.GREY_WITH_BORDER:
                    names.push('BasicCard--grey-with-border');
                    break;
                case CardStyle.GREEN:
                    names.push('BasicCard--green');
                    break;
                case CardStyle.BLUE_100:
                    names.push('BasicCard--blue-100');
                    break;
                case CardStyle.TRANSPARENT:
                    names.push('BasicCard--transparent');
                    break;
                case CardStyle.WARNING:
                    names.push('BasicCard--warning');
                    break;
                case CardStyle.DANGER_2:
                    names.push('BasicCard--danger-2');
                    break;
                case CardStyle.BLUE_50:
                    names.push('BasicCard--blue-50');
                    break;
            }
            return names;
        });
        const flagClassNames = computed(() => {
            if (props.cardStyle === 'info' || props.cardStyle === 'danger')
                return;
            const names = [];
            switch (props.flagPosition) {
                case 'top':
                    names.push('BasicCard__flag--top');
                    break;
                case 'bottom':
                    names.push('BasicCard__flag--bottom');
                    break;
                case 'left':
                    names.push('BasicCard__flag--left');
                    break;
                case 'right':
                    names.push('BasicCard__flag--right');
                    break;
            }
            switch (props.flagColor) {
                case 'red':
                    names.push('BasicCard__flag--red');
                    break;
                case 'blue':
                    names.push('BasicCard__flag--blue');
                    break;
                case 'green':
                    names.push('BasicCard__flag--green');
                    break;
                case 'orange':
                    names.push('BasicCard__flag--orange');
                    break;
                case 'yellow':
                    names.push('BasicCard__flag--yellow');
                    break;
            }
            return names;
        });
        const computedTo = computed(() => {
            if (props.isLoading)
                return null;
            return props.to;
        });
        const click = (event) => {
            const clickable = props.clickable || props.clickableNoStyle;
            if (props.isLoading || !clickable)
                return;
            emit('click', event);
        };
        return {
            classNames,
            click,
            componentIs,
            computedTo,
            flagClassNames,
        };
    },
});

export { script as default };
